class CustomSelectNew extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: 'open' });
    this.options = [];
    this.selectedValue = '';
    this.isOpen = false;
  }

  static get observedAttributes() {
    return ['value', 'placeholder'];
  }

  connectedCallback() {
    // this.render();
    // this.setupEventListeners();
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === 'value') {
      this.selectedValue = newValue;
      this.updateSelectedDisplay();
    }
    if (name === 'placeholder') {
      this.updatePlaceholder();
    }
  }

  setOptions(options) {
    this.options = options;
    const groupedOptions = options.reduce((acc, item) => {
      const key = item.series;
      if (!acc[key]) acc[key] = [];
      acc[key].push(item);
      return acc;
    },{})
    console.log(groupedOptions,1111111);
    
    if(groupedOptions)this.render(groupedOptions);
    this.setupEventListeners();
  }

  render(groupedOptions) {
    const styles = `
      :host {
        display: inline-block;
        position: relative;
        width: 200px;
      }
      .select-container {
        position: relative;
      }
      .select-input {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 8px;
        border: 1px solid #dcdfe6;
        border-radius: 12px;
        padding: 16px;
        cursor: pointer;
        background: #fff;
      }
      .select-arrow {
        border: solid #101820;
        border-width: 0 2px 2px 0;
        display: inline-block;
        padding: 3px;
        transform: rotate(45deg) translateY(-50%);
        transition: transform 0.3s ease;
      }
      .select-arrow.open {
        transform: rotate(-135deg) translateY(-50%);
      }
      .select-dropdown {
        position: absolute;
        top: 100%;
        left: 0;
        right: 0;
        background: #fff;
        border-radius: 12px;
        margin-top: 4px;
        overflow-y: hidden  ;
        opacity: 0;
        transform: translateY(-10px);
        visibility: hidden;
        transition: all 0.3s ease;
        z-index: 1000;
        //box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
        border:1px solid #1018201A;
        pointer-events: none;
      }
      .select-dropdown-con {
        width:100%;
        height:100%;
        overflow-y: auto;
        max-height: 450px;
      }
      .select-dropdown.open {
        opacity: 1;
        transform: translateY(0);
        visibility: visible;
        pointer-events: auto;
      }
      .select-option, .select-group {
        cursor: pointer;
        transition: all 0.2s ease;
        border-bottom: 1px solid #1018201A;
        color: #101820;
        font-size: 12px;
        line-height: 1.6;
        padding: 13px 16px 11px;
        font-family: vinron;
        font-weight: 700;
        opacity: 0.8;
        display: flex;
        justify-content: space-between;
        gap: 8px;
      }
      .select-group {
        background:#1018200A;
        opacity: 1;
        cursor: auto;
      }
      .select-option.selected {
        color: #00c389;
      }
      .select-option svg {
      display: none;}
      .select-option.selected svg {
        display: block;}
      .select-option:hover {
        background-color: #f5f7fa;
      }
      .select-option:last-child {
        border-bottom: none;}
      .select-value {
        overflow: hidden;
        text-overflow: ellipsis;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 1;
        display: -webkit-box;
        font-size: 16px;
        color:#101820;
        font-weight: 700;
        font-family: vinron;
        flex:1;
        text-align:center;
      }
      @media (max-width: 768px) {
        .select-input {
          padding: 8px 12px
        }
      }
    `;

    const template = `
      <style>${styles}</style>
      <div class="select-container">
        <div class="select-input">
          <span class="select-value">${this.getDisplayValue().label}</span>
          <span class="select-arrow"></span>
        </div>
        <div class="select-dropdown">
          <div class="select-dropdown-con">
            ${Object.entries(groupedOptions).map(([seriesName, options]) => `
                ${seriesName != "undefined" ? `<div class="select-group">${seriesName}</div>` : ''}
                ${options.map(option => `
                  <div class="select-option ${option.value === this.selectedValue ? 'selected' : ''}" 
                      data-value="${option.value}">
                    <span>${option.label}</span>
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M4.16699 9.57031L8.88104 14.2844L16.5414 6.62403" stroke="#00C389" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>

                  </div>
                `).join('')}
            `).join('')}
          </div>
        </div>
      </div>
    `;

    this.shadowRoot.innerHTML = template;
  }

  setupEventListeners() {
    const container = this.shadowRoot.querySelector('.select-container');
    const input = this.shadowRoot.querySelector('.select-input')
    const dropdown = this.shadowRoot.querySelector('.select-dropdown');
    const options = this.shadowRoot.querySelectorAll('.select-option');

    input.addEventListener('click', () => {
      this.isOpen = !this.isOpen;
      dropdown.classList.toggle('open', this.isOpen);
      this.shadowRoot.querySelector('.select-arrow').classList.toggle('open', this.isOpen);
    });

    options.forEach(option => {
      option.addEventListener('click', (e) => {
        e.stopPropagation();
        const value = option.dataset.value;
        if (this.selectedValue === value) {
          this.closeDropdown();
          return;
        };
        this.selectedValue = value;
        
        this.setAttribute('value', value);
        this.dispatchEvent(new CustomEvent('change', {
          detail: { value }
        }));
        this.closeDropdown();
      });
    });

    // 点击外部关闭下拉框
    document.addEventListener('click', (e) => {
      if (!this.contains(e.target)) {
        this.closeDropdown();
      }
    });
  }

  closeDropdown() {
    this.isOpen = false;
    const dropdown = this.shadowRoot.querySelector('.select-dropdown');
    const arrow = this.shadowRoot.querySelector('.select-arrow');
    dropdown.classList.remove('open');
    arrow.classList.remove('open');
  }

  getDisplayValue() {
    const placeholder = this.getAttribute('placeholder') || '请选择';
    if (!this.selectedValue) return placeholder;
    const selectedOption = this.options.find(option => option.value == this.selectedValue);
    return selectedOption ? selectedOption : placeholder;
  }

  updateSelectedDisplay() {
    const valueDisplay = this.shadowRoot.querySelector('.select-value');
    const options = this.shadowRoot.querySelectorAll('.select-option');
    options.forEach(option => {
      option.classList.remove('selected');
      if (option.dataset.value === this.selectedValue) {
        option.classList.add('selected');
      }
    });
    if (valueDisplay) {
      valueDisplay.innerHTML = this.getDisplayValue().label + (this.getDisplayValue().price ? `<span style="color: #FF5600;margin-left:4px">${this.getDisplayValue().price}</span>` : '');
    }
  }

  updatePlaceholder() {
    this.updateSelectedDisplay();
  }

  setValue(value) {
    this.selectedValue = value;
    this.setAttribute('value', value);
    this.dispatchEvent(new CustomEvent('change', {
      detail: { value }
    }))
  }
}

customElements.define('custom-select-new', CustomSelectNew); 